/* Sock bundle builder (sections/reformly-bb-builder.liquid).

   State is one array of variant ids, `picks`, in slot order. Everything on
   screen — slots, steppers, tier rail, totals, CTA — is derived from it by
   render(). Nothing else holds state, so there is no way for the stepper and
   the slots to disagree.

   THE DISCOUNT SHOWN HERE IS A PREDICTION. Shopify charges; this only displays
   what the configured tiers say it should be. If the automatic discount in
   admin does not match section.settings.tiers, the buyer sees one number here
   and another at checkout. That is a merchandising error this file cannot
   detect, so the section documents it too. */
(function () {
  'use strict';

  function init(root) {
    var MAX = parseInt(root.dataset.max, 10) || 8;
    var TIERS = [];
    var PRODUCTS = [];
    try { TIERS = JSON.parse(root.dataset.tiers) || []; } catch (e) {}
    try { PRODUCTS = JSON.parse(root.dataset.products) || []; } catch (e) {}
    if (!PRODUCTS.length) return;

    /* Ascending by count, so tierFor() can walk it and take the last match. */
    TIERS.sort(function (a, b) { return a.at - b.at; });

    /* MINIMUM BUNDLE SIZE — the first tier's threshold.
       A bundle of one is not a bundle: there is no tier for it, so it would
       check out at full price while the page has been talking about savings
       throughout. The export disables its button until two pairs are in and
       says "Minimum 2 pairs" beside the total; this is that rule, taken from
       the tiers rather than hardcoded so changing the first tier moves the
       minimum with it. */
    var MIN = TIERS.length ? TIERS[0].at : 1;

    var byId = {};
    PRODUCTS.forEach(function (p) { byId[p.id] = p; });

    var picks = [];

    /* Membership upsell. The button carries its own variant and percentage, so
       an unconfigured section simply has no button and `member` stays false
       forever. */
    var memberCard = root.querySelector('[data-rbb-member]');
    var memberBtn = root.querySelector('[data-rbb-member-toggle]');
    var memberDetail = root.querySelector('[data-rbb-member-detail]');
    var memberBar = root.querySelector('[data-rbb-member-info]');
    /* ONE order-level rate, not a ladder.
       This used to be a per-tier table of combined percentages (28 / 34.3 /
       39.7 / 50.5) because the two discounts could not stack: admin carried a
       single product discount per tier holding the whole figure. They stack now
       — the bundle is a product discount and REFORMLY GOLD MEMBER is an order
       discount — so the page must model the same two steps the cart takes, or
       it quotes a total that is a couple of cents out and drifts further at the
       higher tiers. */
    var MEMBER_RATE = 0;
    if (memberBtn) MEMBER_RATE = parseFloat(memberBtn.dataset.rate) || 0;
    var MEMBER_VARIANT = memberBtn ? parseInt(memberBtn.dataset.variant, 10) : 0;
    /* The membership is a SUBSCRIPTION. Without selling_plan on the line,
       /cart/add.js happily accepts the variant as a one-time purchase — the
       buyer is charged once, no subscription is created, and nothing surfaces
       the mistake until the second month never bills. */
    var MEMBER_PLAN = memberBtn ? parseInt(memberBtn.dataset.sellingPlan, 10) : 0;
    var member = false;

    /* The detail block has TWO different owners, one per breakpoint.

       Desktop: the export renders it under `<sc-if value="{{ member }}">` and
       ships no disclosure at all — so it is open exactly when the toggle is on.
       Phone: the black bar is the disclosure and owns aria-expanded; flipping
       the switch only brings the bar up, collapsed.

       This used to force `hidden = true` on every toggle, which is only the
       phone rule — on desktop the card never opened. */
    var deskMQ = window.matchMedia('(min-width: 900px)');

    function syncMember() {
      var desk = deskMQ.matches;

      if (memberDetail) {
        if (desk) {
          memberDetail.hidden = !member;
        } else {
          var open = !!memberBar && memberBar.getAttribute('aria-expanded') === 'true';
          memberDetail.hidden = !(member && open);
        }
      }

      /* The subtitle swaps to the pricing terms on the PHONE only. The desktop
         export hardcodes "No commitment · Cancel anytime" and never touches it
         — it does not need to, because the detail below is already open and
         carries the price. Swapping it at both widths put the terms in two
         places on desktop and left the static line unused. */
      var subEl = root.querySelector('[data-rbb-membersub]');
      if (subEl) {
        var next = desk ? subEl.dataset.off : (member ? subEl.dataset.on : subEl.dataset.off);
        if (next) subEl.textContent = next;
      }
    }

    /* Crossing the breakpoint with the toggle on has to re-evaluate, or both
       the detail and the subtitle keep whatever the other layout left behind. */
    if (deskMQ.addEventListener) deskMQ.addEventListener('change', syncMember);
    else if (deskMQ.addListener) deskMQ.addListener(syncMember);

    var railBar = root.querySelector('[data-rbb-tiers]');
    /* ---------- sticky host (phone) ----------
       STICKY, NOT FIXED. A `position: fixed` element is positioned against the
       VISUAL viewport, and on mobile the address bar collapsing on a downward
       swipe desyncs the visual and layout viewports — the browser shifts fixed
       boxes by the bar's height until they resync. That displacement lands on
       whatever frame it likes, which is the jank that survived the easing, the
       hysteresis, the dwell lock and the pixel-parked transform.

       A sticky element is positioned against its SCROLL CONTAINER instead, so
       it is immune to that. It is also why the theme's own nav — `position:
       sticky` — has never shown this while our bar did.

       Sticky needs to be in flow, which a top bar must not be, so the host is a
       ZERO-HEIGHT sticky box and the rail is absolutely positioned inside it.
       The host takes no space and pins at top: 0.

       Placed inside the section root, NOT #MainContent: the rail reads
       --rbb-railh and the whole --rbb-* palette by inheritance, and moving it
       out of .rbb would strip all of them. */
    var railHome = railBar ? railBar.parentNode : null;
    var railAfter = railBar ? railBar.nextSibling : null;
    var railHost = null;

    function placeRail() {
      if (!railBar || !railHome) return;
      if (deskMQ.matches) {
        if (railBar.parentNode !== railHome) railHome.insertBefore(railBar, railAfter);
        if (railHost && railHost.parentNode) railHost.parentNode.removeChild(railHost);
        return;
      }
      if (!railHost) {
        railHost = document.createElement('div');
        railHost.className = 'rbb__railhost';
      }
      if (railHost.parentNode !== root) root.insertBefore(railHost, root.firstChild);
      if (railBar.parentNode !== railHost) railHost.appendChild(railBar);
    }

    placeRail();
    if (deskMQ.addEventListener) deskMQ.addEventListener('change', placeRail);
    else if (deskMQ.addListener) deskMQ.addListener(placeRail);

    /* ---------- where the detail lives ----------
       The export NESTS it: on desktop the detail is a child of the membership
       card's wrapper, inside the same border and radius, with no background or
       border of its own —

         <div card: border 1px, radius 14, overflow hidden>
           <button row>
           <div detail: padding 0 14 14; border-top 1px #F0F0F0>

       so "flush" is structural, not a margin that cancels the panel's gap. Our
       markup has them as SIBLINGS because the phone sheet needs the detail
       between the black bar and the totals, which is a different place in the
       document entirely.

       One element, two homes: move it into the card on desktop and back out on
       phones. That is what makes the two read as one card instead of two, and
       it removes the whole class of bug where a negative margin and an `order`
       drift apart in the stylesheet. */
    var detailHome = memberDetail ? memberDetail.parentNode : null;
    var detailAfter = memberDetail ? memberDetail.nextSibling : null;

    function placeDetail() {
      if (!memberDetail || !memberCard || !detailHome) return;
      if (deskMQ.matches) {
        if (memberDetail.parentNode !== memberCard) memberCard.appendChild(memberDetail);
      } else if (memberDetail.parentNode !== detailHome) {
        detailHome.insertBefore(memberDetail, detailAfter);
      }
    }

    placeDetail();
    if (deskMQ.addEventListener) deskMQ.addEventListener('change', placeDetail);
    else if (deskMQ.addListener) deskMQ.addListener(placeDetail);

    var slotsEl = root.querySelector('[data-rbb-slots]');
    var gridEl = root.querySelector('[data-rbb-grid]');
    var fmt = root.dataset.moneyFormat || '${{amount}}';

    /* ---------- money ----------
       Prices arrive from Liquid in CENTS, like every Shopify money field, and
       are only ever divided at the point of display. Doing the arithmetic in
       cents avoids the floating-point drift that shows up as a total one cent
       off the sum of its lines. */
    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + parts[1])
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.'));
    }

    /* ---------- Shopify's own money arithmetic ----------
       Verified against a real cart (4 x $22 at 34.3%):

         original_price    2200
         final_price       1446   = 2200 - floor(2200 * 0.343)
         final_line_price  5784   = 1446 * 4
         discount          3016   =  754 * 4

       Shopify FLOORS the per-unit discount to whole cents and then multiplies
       by quantity. It does not discount the line and divide, and it does not
       round — 2200 * 0.343 = 754.6 becomes 754, not 755.

       Getting this wrong is not cosmetic: rounding the line gave 5782, so the
       page quoted $57.82 against a checkout of $57.84. Any per-unit price and
       any total on this page goes through here. */
    function unitCents(wasCents, pct) {
      return wasCents - Math.floor(wasCents * pct / 100);
    }

    /* Display price for one unit: tier rate, then the member rate off what is
       left — the same two steps, in the same order, as the cart.

         2200 -> unitCents(2200, 27) = 1606   the cart's line price
              -> unitCents(1606, 10) = 1446   after REFORMLY GOLD MEMBER

       1446 x 4 = 5784 while the real line total is 5782, because an order
       discount has no per-unit value to be exact about. The TOTAL is computed
       from the line, not from this, so the figure the buyer commits to stays
       right; this is the indicative per-pair price, and it matches what the
       cart drawer shows on the line. */
    function displayUnit(wasCents, tierPct) {
      var u = unitCents(wasCents, tierPct);
      if (member && MEMBER_RATE > 0) u = unitCents(u, MEMBER_RATE);
      return u;
    }

    /* Highest tier whose threshold the count has reached; null below the first. */
    function tierFor(count) {
      var hit = null;
      for (var i = 0; i < TIERS.length; i++) if (count >= TIERS[i].at) hit = TIERS[i];
      return hit;
    }

    function nextTier(count) {
      for (var i = 0; i < TIERS.length; i++) if (count < TIERS[i].at) return TIERS[i];
      return null;
    }

    /* ---------- mutations ---------- */
    function add(id) {
      /* NO CAP. MAX is the tier ladder's top rung, not a basket limit — the
         export lets you keep adding past 8 ("items beyond 8 stay visible") and
         simply stops increasing the discount, because `eff = min(count, MAX)`.
         Blocking the 9th pair refused a larger order for no reason. */
      var p = byId[id];
      if (!p || !p.available) return;
      picks.push(id);
      render();
    }

    function removeOne(id) {
      /* LAST occurrence, not the first: the slots read left to right, so
         decrementing should take the most recently added pair away rather than
         shuffling everything down from the start. */
      for (var i = picks.length - 1; i >= 0; i--) {
        if (picks[i] === id) { picks.splice(i, 1); break; }
      }
      render();
    }

    function removeSlot(index) {
      if (index < 0 || index >= picks.length) return;
      picks.splice(index, 1);
      render();
    }

    /* ---------- render ---------- */
    function render() {
      var count = picks.length;
      var tier = tierFor(count);
      var pct = tier ? tier.pct : 0;

      /* --- slots --- */
      /* Render a slot per pick once the basket passes MAX, so a 9th pair is
         visible rather than silently absent from the rail. */
      if (slotsEl && picks.length > slotsEl.children.length) {
        for (var extra = slotsEl.children.length; extra < picks.length; extra++) {
          var li = document.createElement('li');
          li.className = 'rbb__slot is-empty';
          li.dataset.rbbSlot = extra;
          var rm = document.createElement('button');
          rm.type = 'button'; rm.className = 'rbb__slotremove';
          rm.dataset.rbbRemove = extra; rm.setAttribute('aria-label', 'Remove');
          rm.innerHTML = '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
          li.appendChild(rm);
          slotsEl.appendChild(li);
        }
      }
      var slots = slotsEl ? slotsEl.querySelectorAll('[data-rbb-slot]') : [];
      for (var s = 0; s < slots.length; s++) {
        var slot = slots[s];
        var pid = picks[s];
        var rm = slot.querySelector('[data-rbb-remove]');
        var img = slot.querySelector('img');

        if (pid == null) {
          slot.classList.add('is-empty');
          slot.classList.remove('is-filled');
          if (rm) rm.hidden = true;
          if (img) img.remove();
        } else {
          var prod = byId[pid];
          slot.classList.remove('is-empty');
          slot.classList.add('is-filled');
          if (rm) rm.hidden = false;
          if (!img) {
            img = document.createElement('img');
            img.loading = 'lazy';
            img.decoding = 'async';
            slot.insertBefore(img, slot.firstChild);
          }
          if (prod && img.getAttribute('src') !== prod.image) {
            img.src = prod.image;
            img.alt = prod.name;
          }
        }
      }

      /* --- steppers --- */
      var tally = {};
      picks.forEach(function (id) { tally[id] = (tally[id] || 0) + 1; });

      var cards = gridEl ? gridEl.querySelectorAll('[data-rbb-card]') : [];
      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var cid = parseInt(card.dataset.id, 10);
        var q = tally[cid] || 0;
        var qEl = card.querySelector('[data-rbb-qty]');
        var step = card.querySelector('[data-rbb-step]');
        if (qEl) qEl.textContent = q;
        if (step) step.classList.toggle('is-zero', q === 0);
        /* Full bundle disables adding, but never removing. BOTH add buttons —
           the card has two (the big Add and the stepper's plus) and disabling
           only the first left the plus live at MAX. */
        /* Only sold-out disables Add; a full ladder does not. */
        card.querySelectorAll('[data-rbb-add]').forEach(function (b) {
          if (!b.hasAttribute('data-sold')) b.disabled = false;
        });
      }

      /* --- totals ---
         The design's model, verbatim:

           subtotal = sum of COMPARE-AT prices
           discount = subtotal * tierPct / 100
           total    = subtotal - discount

         Compare-at, not the sale price — that is what makes the strike-through
         subtotal and the saving read as large as they do. Falls back to the
         live price for any sock with no compare-at set, otherwise an untagged
         product would count as zero and silently shrink the bundle total.

         One percentage against the whole subtotal, matching how a Shopify
         quantity discount computes. Applying it per line and summing rounds
         differently and drifts a cent or two. */
      var subtotal = 0;
      picks.forEach(function (id) {
        var p = byId[id];
        if (!p) return;
        subtotal += (p.was && p.was > p.price) ? p.was : p.price;
      });

      /* TWO steps, in the cart's order — this is the whole fix.

         Shopify applies the bundle (a PRODUCT discount) per unit, floors each
         unit's discount, and multiplies by quantity. Only then does
         REFORMLY GOLD MEMBER (an ORDER discount) come off the resulting line
         total, floored again.

         Collapsing that into one combined per-unit rate is what put this panel
         2c above the cart on a 4-pair bundle:

           one rate    2200 - floor(2200 * .343) = 1446   x4 = 5784
           two steps   2200 - floor(2200 * .27)  = 1606   x4 = 6424
                       6424 - floor(6424 * .10)         =      5782

         The gap is rounding position, not rate — .73 x .90 = .657 either way —
         and it widens with basket size, so it cannot be nudged away. */
      var total = 0;
      Object.keys(tally).forEach(function (id) {
        var p = byId[id];
        if (!p) return;
        var w = (p.was && p.was > p.price) ? p.was : p.price;
        total += unitCents(w, pct) * tally[id];
      });

      var memberOff = member ? Math.floor(total * MEMBER_RATE / 100) : 0;
      total -= memberOff;

      /* --- per-card unit price ---
         `dispPct = max(currentTier, firstTier)` — the export's own rule. A card
         is NEVER shown at full price: with an empty bundle it already reads at
         the first tier, and every card re-prices as the bundle grows through
         the tiers. Missing this is why the grid looked static.

         Rounded to cents per card. These are display prices for a discount
         Shopify applies at the cart, so a card cannot be a fraction of a cent
         out from what the buyer eventually pays on that line. */
      /* Tier rate here; displayUnit() adds the member rate on top when the
         membership is in the bundle, matching the cart drawer, which allocates
         the order discount down to the line for exactly the same reason. */
      var floorPct = TIERS.length ? TIERS[0].pct : 0;
      var dispPct = Math.max(pct, floorPct);
      /* Gold mark on every card price while the membership is in the bundle. */
      root.querySelectorAll('[data-rbb-gold]').forEach(function (g) { g.hidden = !member; });

      for (var u = 0; u < cards.length; u++) {
        var uc = cards[u];
        var prices = uc.querySelector('[data-was]');
        var unitEl = uc.querySelector('[data-rbb-unit]');
        if (!prices || !unitEl) continue;
        var wasC = parseInt(prices.dataset.was, 10);
        if (!wasC) continue;
        /* This card's own id — `cid` above belongs to the stepper loop and
           holds whichever card it finished on. */
        unitEl.textContent = money(displayUnit(wasC, dispPct));
      }

      var pillEl = root.querySelector('[data-rbb-pill]');
      var totalEl = root.querySelector('[data-rbb-total]');
      var wasEl = root.querySelector('[data-rbb-was]');
      var saveEl = root.querySelector('[data-rbb-save]');
      var minEl = root.querySelector('[data-rbb-min]');
      var ofEl = root.querySelector('[data-rbb-of]');

      if (pillEl) pillEl.textContent = count;
      if (totalEl) totalEl.textContent = money(total);
      if (ofEl) ofEl.textContent = count + ' of ' + MAX;
      /* Shown whenever anything has actually come off, which includes the
         member discount on its own — keying these to the tier alone hid the
         saving for a one-pair bundle with membership on. */
      var saved = subtotal - total;
      var anyOff = count > 0 && saved > 0;
      if (wasEl) {
        wasEl.hidden = !anyOff;
        wasEl.textContent = money(subtotal);
      }
      /* Amount only. The export keeps the percentage in a separate element
         precisely because it reads "(20% + 10%)" when the membership is on,
         which a single recomputed figure cannot express. */
      if (saveEl) {
        saveEl.hidden = !anyOff;
        saveEl.textContent = 'You save ' + money(saved);
      }

      /* The phone sheet's right-hand note. It states the entry requirement
         until it is met, then gets out of the way — showing "Minimum 2 pairs"
         beside a bundle of six reads as an unmet condition. */
      if (minEl) {
        minEl.textContent = count >= MIN ? '' : 'Minimum ' + MIN + ' pairs';
      }

      /* --- tier rail ---
         `progressW = eff / MAX * 100` — the export's own formula. The bar runs
         across ALL the tiers, so it advances steadily and the stops sit at
         their real positions along it.

         An earlier version filled toward the next tier and reset at each one.
         That was wrong twice over: it does not match the design, and it snapped
         the bar to empty at the exact moment a tier was unlocked, which reads
         as losing progress just as you earn it. */
      var fill = root.querySelector('[data-rbb-tierfill]');
      var unlock = root.querySelector('[data-rbb-unlock]');
      var nt = nextTier(count);

      if (fill) {
        fill.style.width = Math.max(0, Math.min(100, (Math.min(count, MAX) / MAX) * 100)) + '%';
      }
      /* The export's own wording, so the phone bar reads exactly as designed. */
      if (unlock) {
        if (nt) {
          var need = nt.at - count;
          unlock.textContent = 'Add ' + need + ' more to unlock ' + nt.pct + '% off';
        } else if (tier) {
          /* The export's literal string at the top tier. */
          unlock.textContent = 'Maximum discount unlocked: ' + tier.pct + '% off';
        } else {
          unlock.textContent = '';
        }
      }

      root.querySelectorAll('[data-rbb-tier]').forEach(function (el) {
        el.classList.toggle('is-hit', count >= parseInt(el.dataset.rbbTier, 10));
      });

      /* --- CTA ---
         The label is written into a child span, never into the button: the
         button also holds the cart icon and `textContent =` would delete it. */
      /* ctaHint — only while the CTA is disabled, and the wording depends on
         how far off the minimum you are. Was a static setting shown always. */
      var hintEl = root.querySelector('[data-rbb-hint]');
      if (hintEl) {
        var shortBy = MIN - count;
        hintEl.hidden = shortBy <= 0;
        if (shortBy > 0) {
          hintEl.textContent = count === 0
            ? (root.dataset.hintEmpty || '')
            : (root.dataset.hintShort || '');
        }
      }

      var cta = root.querySelector('[data-rbb-atc]');
      var ctaText = root.querySelector('[data-rbb-ctatext]');
      /* The export's three states, verbatim:
           count >= 2 -> 'Add to cart'
           count === 1 -> 'Add 1 more pair to continue'
           count === 0 -> 'Add to cart'   (disabled)
         So the label only changes in the one-short case, where it tells the
         buyer exactly what is missing instead of sitting there greyed out with
         no explanation. */
      if (cta && !cta.classList.contains('is-loading')) {
        cta.disabled = count < MIN;
        var ctaCount = root.querySelector('[data-rbb-ctacount]');
        if (ctaCount) {
          ctaCount.hidden = count === 0;
          ctaCount.textContent = count;
        }
        if (ctaText) {
          var short = MIN - count;
          ctaText.textContent = (count > 0 && short > 0)
            ? 'Add ' + short + (short === 1 ? ' more pair' : ' more pairs') + ' to continue'
            : (cta.dataset.label || 'Add to cart');
        }
      }

      syncSlotsBar();
      quickRender();
    }

    /* ---------- events ----------
       Delegated: the grid is server-rendered and the slots are rewritten on
       every change, so per-element listeners would die with the nodes. */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;

      var addBtn = t.closest('[data-rbb-add]');
      if (addBtn) { add(parseInt(addBtn.dataset.rbbAdd, 10)); return; }

      var decBtn = t.closest('[data-rbb-dec]');
      if (decBtn) { removeOne(parseInt(decBtn.dataset.rbbDec, 10)); return; }

      var rmBtn = t.closest('[data-rbb-remove]');
      if (rmBtn) { removeSlot(parseInt(rmBtn.dataset.rbbRemove, 10)); return; }

      var view = t.closest('[data-rbb-view]');
      if (view) {
        /* Let modified clicks through — open in a new tab is a real intent and
           the href is a real product page. */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
        e.preventDefault();
        quickOpen(parseInt(view.dataset.rbbView, 10));
        return;
      }

      if (t.closest('[data-rbb-quick-close]')) { if (qEl) qEl.close(); return; }

      var shot = t.closest('[data-rbb-quick-shot]');
      if (shot) {
        quickShot = parseInt(shot.dataset.rbbQuickShot, 10) || 0;
        if (gallery) gallery.slideTo(quickShot); else quickRender();
        return;
      }

      if (t.closest('[data-rbb-quick-add]') || t.closest('[data-rbb-quick-inc]')) {
        add(quickId); return;
      }
      if (t.closest('[data-rbb-quick-dec]')) { removeOne(quickId); return; }

      var mem = t.closest('[data-rbb-member-toggle]');
      if (mem) {
        member = !member;
        mem.setAttribute('aria-pressed', member ? 'true' : 'false');
        /* The phone sheet's black confirmation strip appears with the
           membership and goes with it. Set BEFORE syncMember(), which reads
           the bar's aria-expanded to decide the phone detail state. */
        if (memberBar) {
          memberBar.hidden = !member;
          if (!member) memberBar.setAttribute('aria-expanded', 'false');
        }
        syncMember();
        render();
        return;
      }

      /* The strip is its own disclosure — it opens the same detail block the
         desktop card uses, rather than duplicating the copy. */
      var bar = t.closest('[data-rbb-member-info]');
      if (bar) {
        var open = bar.getAttribute('aria-expanded') === 'true';
        bar.setAttribute('aria-expanded', open ? 'false' : 'true');
        syncMember();
        return;
      }

      var atc = t.closest('[data-rbb-atc]');
      if (atc) { submit(atc); return; }
    });

    /* ---------- add to cart ----------
       ONE request with every pair, matching the board PDP. Quantities are
       collapsed per variant so a bundle of four identical socks is one line of
       four rather than four lines of one. */
    function submit(btn) {
      /* Guards the minimum a second time. The button is disabled below it, but
         this is the only thing standing between a stray programmatic click and
         a one-pair "bundle" checking out at full price. */
      if (picks.length < MIN || btn.classList.contains('is-loading')) return;

      var tally = {};
      picks.forEach(function (id) { tally[id] = (tally[id] || 0) + 1; });
      var items = Object.keys(tally).map(function (id) {
        return { id: Number(id), quantity: tally[id] };
      });

      /* The membership is a real line, not a display flag. If the toggle
         lowered the total without this, the buyer would be quoted a price the
         cart never honours. */
      if (member && MEMBER_VARIANT) {
        var memLine = { id: MEMBER_VARIANT, quantity: 1 };
        if (MEMBER_PLAN) memLine.selling_plan = MEMBER_PLAN;
        items.push(memLine);
      }

      btn.classList.add('is-loading');
      /* aria-busy is what actually tells a screen reader something is in
         flight; the spinner is decorative. Not `disabled` — moving focus off a
         disabled button loses the user's place — so the guard above is what
         prevents a double submit. */
      btn.setAttribute('aria-busy', 'true');
      var lbl = root.querySelector('[data-rbb-ctatext]');
      if (lbl) lbl.textContent = btn.dataset.adding || 'ADDING...';

      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      /* ?kaching_bundles=true — opt OUT of Kaching Bundles' cart interceptor,
         which replaces window.fetch and rewrites the body of anything matching
         "cart/add", merging its own bundle items over the ones built here. The
         flag is Kaching's own escape hatch (_isInterceptableUrl excludes it) and
         Shopify ignores the unknown query param. See reformly-sp.js. */
      fetch(routeRoot + 'cart/add.js?kaching_bundles=true', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add ' + r.status);
          return r.json();
        })
        .then(function () {
          /* Same handoff the board PDP uses — the Plus drawer is driven
             directly, with the event path as the fallback for any template
             still on the maison drawer. */
          if (window.rfStampCart) window.rfStampCart();
          if (window.rypCart) { window.rypCart.open(); }
          else {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.body.classList.add('js-ajax-cart-open');
          }
          picks = [];
          /* The membership went into the cart; leaving the toggle on would
             offer to add a second one. */
          member = false;
          if (memberBtn) memberBtn.setAttribute('aria-pressed', 'false');
          if (memberBar) { memberBar.hidden = true; memberBar.setAttribute('aria-expanded', 'false'); }
          syncMember();
          render();
        })
        .catch(function (err) {
          console.error('[rbb] add to cart failed:', err);
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          render();
        });
    }


    /* ---------- quick view ----------
       ONE dialog, repopulated per product. The export opens it from both the
       card image and the "View details" link; both stay real anchors to the
       product page so no-JS, middle-click and crawlers still work, and only a
       plain left click is intercepted.

       Price here follows the same dispPct rule as the grid, so the modal and
       the card behind it can never disagree. */
    var qEl = root.querySelector('[data-rbb-quick]');
    var quickId = 0;
    var quickShot = 0;

    function quickPrice(p) {
      /* Same rule as the grid: tier rate only, so the quick view and the card
         behind it quote the cart's line price. */
      var t = tierFor(picks.length);
      var floor = TIERS.length ? TIERS[0].pct : 0;
      var dp = Math.max(t ? t.pct : 0, floor);
      var was = (p.was && p.was > p.price) ? p.was : p.price;
      return { was: was, unit: displayUnit(was, dp) };
    }

    function quickRender() {
      if (!qEl || !quickId) return;
      var p = byId[quickId];
      if (!p) return;
      var pr = quickPrice(p);
      var shots = (p.gallery && p.gallery.length) ? p.gallery
                : [{ full: p.image, thumb: p.image }];
      if (quickShot >= shots.length) quickShot = 0;

      var set = function (sel, txt) {
        var e = qEl.querySelector(sel);
        if (e) e.textContent = txt;
      };
      set('[data-rbb-quick-name]', p.name);
      set('[data-rbb-quick-price]', money(pr.unit));
      set('[data-rbb-quick-was]', money(pr.was));
      set('[data-rbb-quick-save]', 'Save ' + Math.round((1 - pr.unit / pr.was) * 100) + '%');

      /* --- gallery ---
         Slides are rebuilt only when the product changes; re-creating them on
         every qty tick would restart each decode and flash the image. */
      var track = qEl.querySelector('[data-rbb-quick-track]');
      if (track && track.dataset.for !== String(quickId)) {
        track.dataset.for = String(quickId);
        track.textContent = '';
        shots.forEach(function (sh) {
          var sl = document.createElement('div');
          sl.className = 'swiper-slide';
          var im = document.createElement('img');
          im.src = sh.full; im.alt = p.name; im.decoding = 'async';
          sl.appendChild(im);
          track.appendChild(sl);
        });
        buildGallery(shots.length);
      }

      var strip = qEl.querySelector('[data-rbb-quick-thumbs]');
      if (strip) {
        /* Rebuilt only when the product changes — re-creating four <img> on
           every qty tick would restart their decode and flicker the strip. */
        if (strip.dataset.for !== String(quickId)) {
          strip.dataset.for = String(quickId);
          strip.textContent = '';
          shots.forEach(function (sh, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'rbb__quickthumb';
            b.dataset.rbbQuickShot = i;
            var im = document.createElement('img');
            im.src = sh.thumb; im.alt = ''; im.decoding = 'async';
            b.appendChild(im);
            strip.appendChild(b);
          });
        }
        strip.hidden = shots.length < 2;
        syncThumbs(quickShot);
      }

      var q = 0;
      picks.forEach(function (id) { if (id === quickId) q++; });
      var addBtn = qEl.querySelector('[data-rbb-quick-add]');
      var stepEl = qEl.querySelector('[data-rbb-quick-step]');
      if (addBtn) {
        addBtn.hidden = q > 0;
        addBtn.disabled = !p.available;
      }
      if (stepEl) stepEl.hidden = q === 0;
      set('[data-rbb-quick-qty]', q + ' in bundle');

      var ship = qEl.querySelector('[data-rbb-shipdate]');
      if (ship && !ship.textContent) {
        var days = parseInt(root.dataset.shipDays, 10);
        if (days > 0) {
          /* Always tomorrow. Not + days, and no weekend skipping — per Dhyaan,
             +1 whatever the day. The `ship_days` setting now only decides
             whether the row shows at all (0 hides it, see the section's
             Liquid); its value no longer moves the date. */
          var d = new Date();
          d.setDate(d.getDate() + 1);
          ship.textContent = d.toLocaleDateString(undefined, {
            weekday: 'short', day: 'numeric', month: 'short'
          });
        }
      }
    }

    /* One Swiper instance, rebuilt per product. Destroyed first so slides from
       the previous product cannot linger in its internal state.

       `loop` is off deliberately: with two or three shots Swiper has to clone
       slides to loop, and the clones confuse the thumb index. */
    var gallery = null;

    function buildGallery(count) {
      if (gallery) { gallery.destroy(true, true); gallery = null; }
      var el = qEl && qEl.querySelector('[data-rbb-quick-swiper]');
      if (!el || typeof window.Swiper !== 'function' || count < 2) {
        syncThumbs(0);
        return;
      }
      gallery = new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 320,
        /* No `navigation` — the pinned prev/next buttons are gone, replaced by
           the follow-cursor below (same control as reformly-bp's gallery). */

        /* LOOPING, matching reformly-bp-hero.js. Cloned slides are what made
           this `false` before: activeIndex COUNTS clones and realIndex does
           not, so the thumbnails tracked the wrong shot. Using realIndex below
           and slideToLoop() for the reset fixes that properly, and looping
           removes the dead first/last edges entirely.

           loopAdditionalSlides: Swiper 11 shifts slides around the active one;
           reversing before a transition ends forces an instant re-translate,
           which is one janky frame. A spare slide either side means the
           reversal target is already in place.

           loopPreventsSliding defaults to true, so a reverse swipe mid-
           animation is swallowed and applied only once the first transition
           ends — that swallowed gesture reads as a dropped frame. */
        loop: true,
        loopAdditionalSlides: 1,
        loopPreventsSliding: false,
        /* Warm the neighbours so swiping does not hit a grey box then pop-in. */
        lazyPreloadPrevNext: 2,
        /* Vertical page scrolling must still work when a drag starts mostly
           vertically on the image — same values as bp. */
        touchReleaseOnEdges: true,
        threshold: 4,
        touchAngle: 40,
        longSwipesRatio: 0.25,
        resistanceRatio: 0.6,
        a11y: { enabled: true },
        on: {
          slideChange: function () {
            quickShot = this.realIndex;
            syncThumbs(quickShot);
          }
        }
      });
      /* slideToLoop, not slideTo — the clone-aware form. */
      gallery.slideToLoop(0, 0);
      syncThumbs(0);
    }

    /* ---------- gallery hover cursor (desktop) ----------
       Ported from reformly-bp-hero.js so this gallery and the PDP's behave
       identically: a disc that follows the pointer, its glyph flipped by
       scaleX(-1) over the left half, and a click that pages whichever way the
       arrow points.

       DEAD EDGES. `loop` is off, so the first slide has nothing to its left and
       the last nothing to its right. Over those halves the disc hides rather
       than advertising a click that cannot happen — Swiper's own
       `swiper-button-disabled` does the same job for its arrows.

       Bound ONCE here rather than inside buildGallery() — that runs on every
       open, and re-binding there would stack a listener set per product viewed.
       It reads `gallery` live, so it works with whatever Swiper is current and
       no-ops when there is none (single-image products). */
    var quickMain = qEl && qEl.querySelector('[data-rbb-quick-swiper]');
    var quickCursor = qEl && qEl.querySelector('[data-rbb-quick-cursor]');
    var cursorSvg = quickCursor && quickCursor.querySelector('svg');
    /* Last pointer position, so a slide change can re-evaluate the edges
       without waiting for the pointer to move. Clicking through to the last
       slide otherwise left a live-looking arrow sitting under a still cursor. */
    var quickPtrX = 0;
    var quickPtrY = 0;
    var quickPtrIn = false;

    function cursorOn() {
      return deskMQ.matches && !!gallery;
    }

    function updateQuickCursor() {
      if (!quickMain || !quickCursor) return;
      if (!quickPtrIn || !cursorOn()) {
        quickCursor.classList.remove('is-visible');
        return;
      }
      var rect = quickMain.getBoundingClientRect();
      var next = (quickPtrX - rect.left) >= rect.width / 2;
      if ((next && gallery.isEnd) || (!next && gallery.isBeginning)) {
        quickCursor.classList.remove('is-visible');
        return;
      }
      quickCursor.classList.add('is-visible');
      quickCursor.style.left = quickPtrX + 'px';
      quickCursor.style.top = quickPtrY + 'px';
      if (cursorSvg) cursorSvg.style.transform = next ? '' : 'scaleX(-1)';
    }

    if (quickMain && quickCursor) {
      quickMain.addEventListener('mouseenter', function () {
        quickPtrIn = true;
      });

      quickMain.addEventListener('mouseleave', function () {
        quickPtrIn = false;
        quickCursor.classList.remove('is-visible');
      });

      quickMain.addEventListener('mousemove', function (e) {
        quickPtrIn = true;
        quickPtrX = e.clientX;
        quickPtrY = e.clientY;
        updateQuickCursor();
      });

      quickMain.addEventListener('click', function (e) {
        if (!cursorOn()) return;
        var rect = quickMain.getBoundingClientRect();
        if (e.clientX - rect.left >= rect.width / 2) {
          if (!gallery.isEnd) gallery.slideNext();
        } else if (!gallery.isBeginning) {
          gallery.slidePrev();
        }
      });
    }

    function syncThumbs(i) {
      if (!qEl) return;
      qEl.querySelectorAll('.rbb__quickthumb').forEach(function (b, n) {
        b.classList.toggle('is-on', n === i);
      });
    }

    function quickOpen(id) {
      if (!qEl || !byId[id]) return;
      quickId = id;
      quickShot = 0;
      /* The export re-sets `faq: 0` on every view(), so the first row is open
         each time the overlay opens — not just the first time. Without this,
         whatever the previous product's overlay was left on would persist. */
      var faqs = qEl.querySelectorAll('.rbb__faq');
      for (var f = 0; f < faqs.length; f++) faqs[f].open = (f === 0);
      quickRender();
      if (typeof qEl.showModal === 'function') qEl.showModal();
      else qEl.setAttribute('open', '');

      /* showModal() focuses the first focusable DESCENDANT, which here is the
         close button — so opening the sheet by tapping "View details" left a
         UA focus ring drawn around the cross until you tapped somewhere else.

         Move the initial focus to the dialog itself (it carries tabindex="-1").
         Focus stays inside the modal, so Escape and the focus trap still work
         and Tab still reaches the close button first — but no control is
         focused on open, so nothing is ringed. Do NOT "fix" this by removing
         the button's outline: that would take the ring away from keyboard
         users too. */
      qEl.focus({ preventScroll: true });
    }

    if (qEl) {
      /* Clicking the backdrop closes it. The dialog element IS the backdrop
         area, so a click whose target is the dialog itself landed outside the
         inner panel. */
      qEl.addEventListener('click', function (e) {
        if (e.target === qEl) qEl.close();
      });
      qEl.addEventListener('close', function () {
        quickId = 0;
        if (gallery) { gallery.destroy(true, true); gallery = null; }
        var tr = qEl.querySelector('[data-rbb-quick-track]');
        if (tr) tr.dataset.for = '';
      });
    }

    /* ---------- filters ----------
       Built from the tags actually present, so an untagged collection shows no
       filter bar rather than an empty one. Filtering is client-side because the
       whole collection is already on the page — a server round trip for ten
       products would be slower and would lose the bundle in progress. */
    function buildFilters() {
      var wrap = root.querySelector('[data-rbb-filters]');
      var toggle = root.querySelector('[data-rbb-filter-toggle]');
      var tally = root.querySelector('[data-rbb-tally]');

      /* The count is true whether or not anything is filterable, and the
         toolbar it lives in draws the rule above the grid — so it is filled in
         before the early return below. */
      if (tally) tally.textContent = PRODUCTS.length + ' of ' + PRODUCTS.length;
      if (!wrap) return;

      /* The export's model, which mine did not match:
           style  = SINGLE select, with an 'All' chip that is the default
           colour = MULTI select, every palette colour always shown
         Mine had style as an on/off toggle with no All, and colour as
         single-select built only from colours present in the collection. */
      var ALL = 'All';
      var styles = [];
      var colours = [];
      var swatchOf = {};
      var labelOf = {};
      PRODUCTS.forEach(function (p) {
        if (p.style && styles.indexOf(p.style) === -1) styles.push(p.style);
        if (p.colour && colours.indexOf(p.colour) === -1) colours.push(p.colour);
        if (p.colour && p.swatch && !swatchOf[p.colour]) swatchOf[p.colour] = p.swatch;
      });
      /* Only the BUTTON is gated: one that opens an empty panel is worse than
         none. Tag the collection `style:…` / `colour:…` and it appears. */
      /* The palette, not the collection, decides which colour chips exist —
         the export maps over COLORS so a colour with nothing in stock still
         shows (and filters to the empty state). It also supplies the display
         label, so "white" renders as "White". */
      var PALETTE = [];
      try { PALETTE = JSON.parse(root.dataset.palette) || []; } catch (e) {}
      PALETTE.forEach(function (c) {
        if (colours.indexOf(c.key) === -1) colours.push(c.key);
        if (!swatchOf[c.key]) swatchOf[c.key] = c.hex;
        labelOf[c.key] = c.name;
      });

      if (!styles.length && !colours.length) return;

      if (toggle) toggle.hidden = false;
      styles.unshift(ALL);
      /* style is a value ('All' means unfiltered); colours is a Set-like list. */
      var active = { style: ALL, colours: [] };

      /* The panel is DISCLOSED by the button, not always on — that is what lets
         the same markup serve the 390 design (one button) and the 1440 one. */
      if (toggle) {
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          wrap.hidden = open;
        });
      }

      /* Style renders as a text pill, colour as a swatch + label — the design
         treats them as two different kinds of facet. A colour with no
         `swatch:` tag falls back to a pill rather than an invisible dot. */
      function chips(host, values, key) {
        if (!host || !values.length) return;
        values.forEach(function (val) {
          var paint = key === 'colour' ? swatchOf[val] : null;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = paint ? 'rbb__swatch' : 'rbb__chip';
          if (paint) {
            var dot = document.createElement('span');
            dot.className = 'rbb__swatchdot';
            dot.style.background = paint;
            b.appendChild(dot);
            b.appendChild(document.createTextNode(labelOf[val] || val));
          } else {
            b.textContent = val;
          }
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () {
            if (key === 'colour') {
              /* Multi-select: tapping a second colour widens the result, it
                 does not replace the first. */
              var at = active.colours.indexOf(val);
              if (at === -1) active.colours.push(val); else active.colours.splice(at, 1);
            } else {
              /* Single-select, and re-tapping the active one falls back to
                 All rather than to "nothing selected". */
              active.style = active.style === val ? ALL : val;
            }
            apply();
          });
          b.dataset.value = val;
          b.dataset.key = key;
          /* insertBefore, not append: Clear already lives in the colour row
             and must stay at its end (margin-left: auto pushes it right). */
          var tail = host.querySelector('[data-rbb-clear]');
          if (tail) host.insertBefore(b, tail); else host.appendChild(b);
        });
      }

      function apply() {
        root.querySelectorAll('.rbb__chip, .rbb__swatch').forEach(function (c) {
          var on = c.dataset.key === 'colour'
            ? active.colours.indexOf(c.dataset.value) !== -1
            : active.style === c.dataset.value;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var n = (active.style === ALL ? 0 : 1) + active.colours.length;
        var any = n > 0;
        var clear = root.querySelector('[data-rbb-clear]');
        if (clear) clear.hidden = !any;
        /* "Filter (2)" — the export's filterCount, so a closed panel still
           shows that something is filtering the grid. */
        var cnt = root.querySelector('[data-rbb-filter-count]');
        if (cnt) cnt.textContent = n ? ' (' + n + ')' : '';

        var shown = 0;
        root.querySelectorAll('[data-rbb-card]').forEach(function (card) {
          var p = byId[parseInt(card.dataset.id, 10)];
          var ok = !!p
            && (active.style === ALL || p.style === active.style)
            && (!active.colours.length || active.colours.indexOf(p.colour) !== -1);
          card.hidden = !ok;
          if (ok) shown++;
        });
        if (tally) tally.textContent = shown + ' of ' + PRODUCTS.length;

        /* Filtering to nothing is a state, not an absence. Without this the
           grid silently empties and the page reads as broken. */
        var emptyEl = root.querySelector('[data-rbb-empty]');
        if (emptyEl) emptyEl.hidden = shown > 0;
        if (gridEl) gridEl.hidden = shown === 0;
      }

      chips(root.querySelector('[data-rbb-chips-style]'), styles, 'style');
      chips(root.querySelector('[data-rbb-chips-colour]'), colours, 'colour');

      /* querySelectorAll: the reset appears twice — in the filter bar and in
         the empty state. Binding only the first left the empty state's link
         dead, which is the one a stuck shopper actually reaches for. */
      root.querySelectorAll('[data-rbb-clear]').forEach(function (c) {
        c.addEventListener('click', function () {
          active.style = ALL; active.colours = []; apply();
        });
      });

      apply();
    }

    /* ---------- slot rail ----------
       Eight 72px slots do not fit a 360px panel, so the rail scrolls. The real
       scrollbar is suppressed and the design draws its own 4px track with a
       proportional thumb underneath; the arrows nudge it on desktop and are
       hidden by CSS on phones, where it is swiped.

       Arrows are hidden outright when there is nothing to scroll — a control
       that visibly does nothing is worse than no control. */
    var prev = root.querySelector('[data-rbb-slots-prev]');
    var next = root.querySelector('[data-rbb-slots-next]');
    var slotsBar = root.querySelector('[data-rbb-slotsbar]');

    function nudge(dir) {
      if (!slotsEl) return;
      slotsEl.scrollBy({ left: dir * slotsEl.clientWidth * 0.8, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    function syncSlotsBar() {
      if (!slotsEl) return;
      var view = slotsEl.clientWidth;
      var full = slotsEl.scrollWidth;
      var left = slotsEl.scrollLeft;
      var overflows = full - view > 1;

      /* Each arrow answers its OWN question, exactly as the export does:
           prev -> have we scrolled away from the start?   (left > 4)
           next -> is there anything still to the right?   (full - view - left > 4)
         So at rest the left arrow is invisible and only the right one shows —
         toggling both together on "does the rail overflow" put a left arrow on
         screen pointing back at nothing.

         The 4px slack absorbs sub-pixel scroll positions, which otherwise leave
         an arrow faintly on at what is visually the end of the rail.

         Opacity and pointer-events rather than `hidden`: the design fades them
         over 200ms, and a display:none element cannot transition. */
      function arrow(el, on) {
        if (!el) return;
        el.style.opacity = on ? '1' : '0';
        el.style.pointerEvents = on ? 'auto' : 'none';
        /* Still removed from the tab order when it does nothing. */
        el.tabIndex = on ? 0 : -1;
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      arrow(prev, overflows && left > 4);
      arrow(next, overflows && (full - view - left) > 4);

      if (!slotsBar) return;
      slotsBar.hidden = !overflows;
      if (!overflows) return;

      /* Thumb width is the visible fraction of the rail, floored at 24px so it
         stays grabbable, and its travel is over the remaining track. */
      var track = slotsBar.clientWidth;
      var w = Math.max(24, Math.round((view / full) * track));
      var maxScroll = full - view;
      var x = maxScroll > 0 ? (slotsEl.scrollLeft / maxScroll) * (track - w) : 0;
      slotsBar.style.setProperty('--rbb-thumb-w', w + 'px');
      slotsBar.style.setProperty('--rbb-thumb-x', Math.round(x) + 'px');
    }

    if (slotsEl) slotsEl.addEventListener('scroll', syncSlotsBar, { passive: true });
    window.addEventListener('resize', syncSlotsBar);

    /* ---------- phone chrome ----------
       Below 900 the panel is a fixed sheet and the tier rail is a fixed bar.
       Both overlay the page, so two things have to be true:

       1. the grid must end above the sheet. Its height is content-dependent
          (a long unlock message, a wrapped total) so it is measured rather
          than guessed at in CSS — a hardcoded clearance is either a gap or a
          covered CTA the moment the copy changes.
       2. the rail must not cover the heading. The export slides it in by
          animating `top`; the trigger is the grid coming into view, which is
          also the first moment the bar has anything to say. */
    var panelEl = root.querySelector('.rbb__panel');

    /* --rbb-headroom is what the sticky panel and the fixed phone rail clear.
       The export hardcodes 150px against ITS header, which tells us nothing
       about this theme's — and the theme's header height differs between
       phone and desktop anyway. So measure it.

       Only a header that actually sticks can overlap us; a static one scrolls
       away and needs no clearance at all. */
    function headerEl() {
      return document.querySelector('sticky-header, .section-header, #shopify-section-header');
    }

    function syncHeadroom() {
      /* MEASURE FIRST, theme variable second.

         sticky-header.js publishes --header-height, but it only recomputes on
         `matchMedia('(max-width: 990px)').change` — crossing that one
         breakpoint. The nav row reflows at plenty of other widths, so the
         variable is stale for most of the range and the panel tucked under the
         bar. Reading the element is always current.

         The element that actually pins is `.section-header`, NOT
         `.header-wrapper`: an earlier version tested `.header-wrapper` for
         `position: sticky`, saw `static`, and returned 0. The announcement bar
         above it is static and scrolls away, so it must NOT be counted. */
      var pad = 0;
      var h = headerEl();
      if (h) {
        var pos = getComputedStyle(h).position;
        var always = h.getAttribute && h.getAttribute('data-sticky-type') === 'always';
        if (always || pos === 'sticky' || pos === 'fixed') {
          pad = h.getBoundingClientRect().height;
        }
      }
      if (!pad) {
        var themeVar = getComputedStyle(document.documentElement)
          .getPropertyValue('--header-height');
        pad = parseFloat(themeVar) || 0;
      }
      root.style.setProperty('--rbb-headroom', Math.round(pad) + 'px');

    }

    syncHeadroom();
    window.addEventListener('resize', syncHeadroom);
    /* Webfonts and the logo image both land after first paint and can change
       the bar's height. */
    window.addEventListener('load', syncHeadroom);
    /* Catches every other cause — the nav row wrapping, a promo line being
       added, the sticky class changing padding — without guessing at which. */
    if (window.ResizeObserver) {
      var hEl = headerEl();
      if (hEl) new ResizeObserver(syncHeadroom).observe(hEl);
    }

    function syncSheet() {
      if (!panelEl) return;
      var phone = !window.matchMedia('(min-width: 900px)').matches;
      var h = phone ? panelEl.offsetHeight : 0;
      root.style.setProperty('--rbb-sheet', h + 'px');
      /* On <body>, not on our wrap. The sheet is fixed to the viewport, so the
         clearance has to sit at the END of the document — past the footer —
         or the footer gets pushed down by the sheet's height and a gap opens
         under the last row of cards. The export uses a spacer div after its
         footer for exactly this. */
      document.body.style.paddingBottom = h ? h + 'px' : '';
    }

    syncSheet();
    window.addEventListener('resize', syncSheet);
    /* The sheet's own height changes with its contents (the total gains a
       strike-through, the minimum note clears), so re-measure after a render
       rather than only on resize. */
    var sheetObserver = window.ResizeObserver ? new ResizeObserver(syncSheet) : null;
    if (sheetObserver && panelEl) sheetObserver.observe(panelEl);

    /* ---------- the tier rail ----------

       The export slides its nav out and drops the progress rail into the space
       it leaves:
         headY   = headHidden ? '-93px' : '0px'
         progTop = headHidden ? '0px'  : '-88px'

       WE DO NOT DO THAT, deliberately. Moving the nav and the rail at once is
       not fixable on mobile — see below. The rail slides in OVER the nav
       instead, which looks the same (an opaque bar arriving at the top of the
       screen) without the failure mode.

       Rule is still the export's own: past 140px and moving down brings the
       rail in, moving up takes it away. rAF-throttled, passive listener.

       Scoped by load: this script runs only where the section does. */
    /* THE NAV IS NEVER HIDDEN. The rail slides in OVER it.

       Hiding the nav meant two elements animating at once, and on mobile that
       is not fixable: when the address bar collapses on a downward swipe the
       layout and visual viewports desync, `position: fixed` boxes shift by the
       bar height until they resync, and the two halves separate — which is the
       gap with page text in it. One moving element has nothing behind it but an
       opaque nav that has not moved. */
    /* Cached — matchMedia() was being constructed on every accepted sample. */
    var deskMQ2 = window.matchMedia('(min-width: 900px)');
    var isPhone = function () { return !deskMQ2.matches; };

    /* HYSTERESIS, not a raw deadzone.

       The first version compared each sample against the last ACCEPTED sample
       and flipped as soon as the sign changed by 6px. Momentum scrolling and
       iOS rubber-banding reverse that sign constantly at low speed, so the two
       classes toggled several times a second and the bar strobed.

       Instead: hold an anchor at the last direction change, let it TRAIL the
       scroll while moving the same way, and require RAIL_HYST px against the
       current state before flipping. A reversal smaller than that never
       reaches the DOM at all. */
    /* ASYMMETRIC thresholds, not one shared value — the enter/exit gap is what
       stops a scroll that wobbles around the trip point from toggling. 28 down
       to bring the rail in, 18 up to give the nav back: revealing the nav is
       the more urgent of the two, because that is how a user reaches the menu,
       so it takes less movement to ask for it. The 10px gap between them is
       wider than any correction a single flick produces. */
    var RAIL_HYST_DOWN = 28;
    var RAIL_HYST_UP = 18;
    /* THE RAIL WAITS FOR THE ANNOUNCEMENT BAR TO GO.

       140 was the export's number, measured against ITS chrome — it means
       nothing here. What the threshold actually wants to express is "the
       announcement bar has scrolled away", because that strip is the space the
       rail takes over. The bar is in normal flow at the very top of the
       document, so the scroll distance that clears it IS its own height.

       Measured, not assumed: the bar's height changes with its copy, with the
       localisation row, and between breakpoints. Falls back to 140 when the
       page has no announcement bar at all, which is the old behaviour. */
    var RAIL_TOP = 140;

    function annEl() {
      return document.querySelector(
        '.utility-bar, .shopify-section-group-header-group:not(.section-header)'
      );
    }

    function syncRailTop() {
      var a = annEl();
      var h = a ? a.getBoundingClientRect().height : 0;
      RAIL_TOP = h > 0 ? Math.round(h) : 140;
    }

    /* Publish the rail's own height in PIXELS for the parked transform.

       The CSS used to park it at translateY(-100%), a percentage of its border
       box — which the compositor resolves against a CACHED size. `will-change`
       promotes the layer before webfonts settle and before render() first
       writes the unlock copy, so that cached size could be stale and the bar
       parked at the wrong offset: it then travelled past its target and
       corrected. A measured pixel value has nothing to go stale. */
    function syncRailHeight() {
      if (!railBar) return;
      var h = Math.ceil(railBar.getBoundingClientRect().height);
      if (h > 0) root.style.setProperty('--rbb-railh', h + 'px');
    }

    function syncRailMetrics() {
      syncRailTop();
      syncRailHeight();
    }

    syncRailMetrics();
    window.addEventListener('load', syncRailMetrics, { passive: true });
    window.addEventListener('resize', syncRailMetrics, { passive: true });
    if (window.ResizeObserver) {
      var aEl = annEl();
      if (aEl) new ResizeObserver(syncRailTop).observe(aEl);
      /* The rail's own height moves with its copy — "Add 2 more to unlock 20%"
         wraps to two lines on a narrow phone where the top tier's label does
         not. Re-measure whenever it reflows. */
      if (railBar) new ResizeObserver(syncRailHeight).observe(railBar);
    }
    var railOn = false;
    var railAnchor = window.scrollY;
    var railRaf = null;

    /* DWELL LOCK — matched to the transition, deliberately.

       Hysteresis stops jitter, but a deliberate scroll back and forth crosses
       the threshold for real, and each crossing restarted a 260ms slide that
       had not finished the last one. A transition reversed part-way reads as a
       flicker rather than a slide.

       320 == the CSS transform duration, so a slide always completes before
       another can start. Shorter (it was 180) let a reversal interrupt a run in
       progress, which is half of what you see on a back-and-forth scroll; the
       other half was the lock replaying a stale intent, which setExchange no
       longer does. Keep this in step with the transition in reformly-bb.css. */
    var RAIL_LOCK = 320;
    var railLockUntil = 0;
    var railLockTimer = null;
    var now = function () {
      return window.performance && window.performance.now ? window.performance.now() : Date.now();
    };

    function setExchange(hide) {
      /* Never touch classList for a no-op — a same-state toggle still costs a
         style recalculation on every frame of a long scroll. */
      if (hide === railOn) return;

      var t = now();
      if (t < railLockUntil) {
        /* DO NOT QUEUE THE REQUEST.

           This used to remember the wanted state and replay it when the lock
           expired. On a back-and-forth scroll that replay fired up to a lock's
           worth of time after the fact, moving the bar in a direction the user
           had already abandoned — and the next tick immediately corrected it.
           That round trip was the flicker.

           Re-evaluating from the CURRENT scroll position instead means a
           delayed decision is never a stale one: if the user reversed twice
           during the hold, the bar simply stays where it is. */
        if (!railLockTimer) {
          railLockTimer = setTimeout(function () {
            railLockTimer = null;
            /* Anchor to here, so the residual movement that happened during the
               hold does not count towards the next flip. */
            railAnchor = Math.max(0, window.scrollY);
            railTick();
          }, railLockUntil - t + 16);
        }
        return;
      }

      railOn = hide;
      railLockUntil = t + RAIL_LOCK;
      root.classList.toggle('rbb--railon', hide);
    }

    function railTick() {
      railRaf = null;

      /* Clamp. iOS reports a NEGATIVE scrollY at the top and past-maximum at
         the bottom while rubber-banding; both read as direction changes and
         were a second source of flicker. */
      var y = window.scrollY;
      if (y < 0) y = 0;

      if (!isPhone() || y <= RAIL_TOP) {
        setExchange(false);
        railAnchor = y;
        return;
      }

      if (y > railAnchor) {
        if (!railOn && y - railAnchor >= RAIL_HYST_DOWN) { setExchange(true); railAnchor = y; }
        else if (railOn) railAnchor = y;
      } else if (y < railAnchor) {
        if (railOn && railAnchor - y >= RAIL_HYST_UP) { setExchange(false); railAnchor = y; }
        else if (!railOn) railAnchor = y;
      }
    }

    window.addEventListener('scroll', function () {
      if (railRaf) return;
      railRaf = requestAnimationFrame(railTick);
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (!isPhone()) {
        setExchange(false);
        railAnchor = window.scrollY;
      }
    }, { passive: true });

    /* Labels live on the button so render() can restore them after the adding
       state without reaching back into Liquid. `empty` falls back to whatever
       the span was rendered with, which is the same setting. */
    var cta = root.querySelector('[data-rbb-atc]');
    var ctaTextEl = root.querySelector('[data-rbb-ctatext]');
    if (cta && ctaTextEl && !cta.dataset.empty) {
      cta.dataset.empty = ctaTextEl.textContent.trim();
    }


    /* Regional-indicator flag for any non-US country: each ASCII letter maps to
       its U+1F1E6.. counterpart. Built here rather than shipped as an asset —
       195 flag images for one 20x14 badge is not a trade worth making, and the
       alternative in this theme is a third-party CDN request.

       Left as the plain ISO code where the platform has no flag glyph (Windows
       renders the letters), which is legible rather than broken. */
    root.querySelectorAll('[data-rbb-flag]').forEach(function (el) {
      var cc = (el.dataset.rbbFlag || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(cc)) return;
      try {
        el.textContent = String.fromCodePoint(
          0x1f1e6 + cc.charCodeAt(0) - 65,
          0x1f1e6 + cc.charCodeAt(1) - 65
        );
      } catch (e) { /* keep the code */ }
    });

    /* ---------- countdown ----------
       Urgency framing, not a real deadline: it starts from `scarcity_minutes`
       on every page load rather than counting to a fixed moment, because there
       is no real moment to count to. Written as such in the setting's help
       text so nobody mistakes it for stock logic.

       setInterval rather than rAF — this ticks once a second and must keep
       running while the tab is backgrounded, where rAF is throttled to a stop.
       Stops at zero instead of going negative. */
    var cdEl = root.querySelector('[data-rbb-countdown]');
    if (cdEl) {
      var left = (parseInt(cdEl.dataset.minutes, 10) || 0) * 60;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var tick = function () {
        var h = Math.floor(left / 3600);
        var m = Math.floor((left % 3600) / 60);
        var sec = left % 60;
        cdEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
        if (left <= 0) clearInterval(timer);
        left--;
      };
      tick();
      var timer = setInterval(tick, 1000);
    }

    buildFilters();
    render();

    /* ---------- headroom ----------
       The sticky panel has to clear whatever is actually pinned at the top,
       and --rbb-headroom was a hardcoded 64px written against the THEME'S old
       sticky header. The V4 nav is taller than that and sits below the
       announcement bar, so the panel pinned at 84px (64 + 20) while the nav
       occupied the top 129 — its first ~45px scrolled behind the nav and
       stayed there.

       Measured rather than hardcoded, for the same reason the socks PDP does
       it (reformly-sp.js, syncHeadroom): the theme's own sticky-header.js
       publishes --header-height but only recomputes it when crossing 990px,
       so it is stale across most of the range, and the V4 nav's height is a
       clamp that changes with the viewport anyway.

       BOTTOM, NOT HEIGHT. The nav is fixed and offset downward by the
       announcement bar, so only its bottom edge accounts for both.

       The old header stays as the fallback for any template still rendering
       it without the nav. */
    function headerEl() {
      return document.querySelector('.rfn') ||
        document.querySelector('sticky-header, .section-header, #shopify-section-header');
    }

    function syncHeadroom() {
      var pad = 0;
      var h = headerEl();
      if (h) {
        var pos = getComputedStyle(h).position;
        var always = h.getAttribute && h.getAttribute('data-sticky-type') === 'always';
        if (always || pos === 'sticky' || pos === 'fixed') {
          pad = Math.max(0, h.getBoundingClientRect().bottom);
        }
      }
      /* Only publish a real measurement. Writing 0 would override the
         stylesheet's fallback and pin the panel against the very top — the
         exact failure the PDP hit when the theme header went display:none. */
      if (pad > 0) root.style.setProperty('--rbb-headroom', Math.round(pad) + 'px');
    }

    syncHeadroom();
    window.addEventListener('load', syncHeadroom, { passive: true });
    window.addEventListener('resize', syncHeadroom, { passive: true });
    if (window.ResizeObserver) {
      var hEl = headerEl();
      if (hEl) new ResizeObserver(syncHeadroom).observe(hEl);
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rbb]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
